export default {
  pending: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    height: '300px',
    padding: '0'
  },
  groupsSelection: {
    animation: '0.3s fadeIn ease-in'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}
